<div class="pop-wrap">
  <div class="pop">
    <div class="pop-icon">
      <svg viewBox="0 0 16 16">
        <use href="#mute" />
      </svg>
    </div>
    <div class="pop-text"><span i18n>Your mic is muted. Click on the mic icon to unmute.</span></div>
    <div class="pop-close" (click)="onClose(); false">
      <svg viewBox="0 0 14 14">
        <use href="#close" />
      </svg>
    </div>
  </div>
</div>
